import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import { getBackendNotifications } from 'actions/notifications/backendNotifications';

import {
    RaisedButton,
    Table,
    TableRow,
    TableHeader,
    TableHeaderColumn,
    TableBody,
    TableRowColumn
} from 'material-ui';

import Create from './Create';
import Update from './Update';
import Delete from './Delete';

import styles from 'styles';

class BackendNotifications extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            openCreate: false,
            openUpdate: false,
            openDelete: false,
            current: '',
        };

        this.toggleCreate = this.toggleCreate.bind(this);
        this.toggleUpdate = this.toggleUpdate.bind(this);
        this.toggleDelete = this.toggleDelete.bind(this);
    }

    toggleDelete(current = '') {
        this.setState({
            openDelete: !this.state.openDelete,
            current,
        });
    }

    toggleCreate() {
        this.setState({
            openCreate: !this.state.openCreate,
        });
    }

    toggleUpdate(current = '') {
        this.setState({
            openUpdate: !this.state.openUpdate,
            current,
        });
    }

    componentDidMount() {
        this.props.getBackendNotifications();
    }

    render() {
        const { openCreate, openUpdate, openDelete, current } = this.state;
        const { backendNotifications: { items } } = this.props;

        return (
            <div id='sender-page' className='table-page'>
                <div className='container'>
                    <h2>Notifications list</h2>

                    <Delete
                        open={openDelete}
                        toggle={this.toggleDelete}
                        deleteId={current}
                    />
                    <Update
                        open={openUpdate}
                        toggle={this.toggleUpdate}
                        updateId={current}
                    />
                    <Create
                        open={openCreate}
                        toggle={this.toggleCreate}
                    />

                    <div className='paper-block margin-10'>
                        <div className='row'>
                            <div className="col-xs-3">
                                <RaisedButton
                                    label='create'
                                    primary
                                    onClick={this.toggleCreate}
                                />
                            </div>
                        </div>
                    </div>

                    <Table selectable={false}>
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    Actual version
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnCSS}>
                                    Message
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Platform
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Required update
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    Show
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    AddedAt
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    {null}
                                </TableHeaderColumn>
                                <TableHeaderColumn style={styles.tableHeaderColumnSmallCSS}>
                                    {null}
                                </TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                       <TableBody displayRowCheckbox={false}>
                            {
                                items.map((item, index) => {
                                    return (<TableRow key={index}>
                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            { item.actualVersion }
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableRowColumnCSS}>
                                            { item.message }
                                        </TableRowColumn>

                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { item.platform }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { item.requiredUpdate ? 'true' : 'false' }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { item.show ? 'true' : 'false' }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            { moment(item.addedAt).format('DD.MM.YYYY') }
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            <RaisedButton
                                                label='delete'
                                                secondary
                                                onClick={() => this.toggleDelete(item._id)}
                                            />
                                        </TableRowColumn>
                                        <TableRowColumn style={styles.tableHeaderColumnSmallCSS}>
                                            <RaisedButton
                                                label='update'
                                                primary
                                                onClick={() => this.toggleUpdate(item._id)}
                                            />
                                        </TableRowColumn>
                                    </TableRow>);
                                })
                            }
                        </TableBody>
                    </Table>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ backendNotifications }) => { return { backendNotifications }; },
    dispatch => bindActionCreators({ getBackendNotifications }, dispatch),
)(BackendNotifications);



// WEBPACK FOOTER //
// ./app/components/BackendNotifications/List.jsx